<div class="feedback-widget-container">
  
  <button (click)="toggleForm()" class="feedback-icon-btn" title="{{ 'zv.form.title' | localize }}">
    💬 
  </button>

  @if (isOpen()){
    <div class="feedback-modal-overlay" (click)="toggleForm()">
      <div #modalContent class="feedback-form-content" (click)="$event.stopPropagation()">
        
        @if (!isSuccess()) {
          <button (click)="toggleForm()" class="close-btn" title="{{ 'zv.form.zavrit' | localize }}">&times;</button>
          <h3>{{ 'zv.form.title' | localize }}</h3>

          <form [formGroup]="zpetnaVazbaForm" (ngSubmit)="onSubmit($event)">
            <div class="gov-form-control" [class.not-empty]="hasValueTypKod()">
              <div class="gov-select gov-js-select">
                <label for="typKod" class="gov-form-control__label filterLabel">{{ 'zv.form.typVazby' | localize }}</label>
                <select id="typKod" formControlName="typKod">
                  @for (ftype of feedbackTypes(); track ftype.typKod){
                      <option [value]="ftype.typKod">{{ ftype.nazev }}</option>
                  }
                </select>
              </div>
            </div>
            
            <div class="gov-form-control" [class.not-empty]="isTextActive()">
              <label for="text" class="gov-form-control__label filterLabel">{{ 'zv.form.popis' | localize }}</label>
              <textarea
                id="text"
                formControlName="text"
                maxlength="300"
                rows="5"
                class="gov-form-control__textarea gov-js-textarea"
                (focus)="isTextFocused.set(true)"
                (blur)="isTextFocused.set(false)"
              ></textarea>
              <div class="char-counter" 
                [class.limit-reached]="(hasValueText()?.length || 0) >= 300">
                {{ hasValueText()?.length || 0 }} / 300
              </div>
            </div>
            
            <div class="gov-form-control" [class.not-empty]="isEmailActive()">
              <label for="email" class="gov-form-control__label filterLabel">{{ 'zv.form.email' | localize }}</label>
              <input 
                type="email" 
                id="email" 
                formControlName="email" 
                class="gov-form-control__input gov-js-input"
                (focus)="isEmailFocused.set(true)"
                (blur)="isEmailFocused.set(false)"
              >
            </div>

            @if (this.errorMessage()) {
              <div class="error-alert">
                ⚠️ {{ this.errorMessage() }}
              </div>
            }
            
            <button type="submit" class="gov-button me-3 gov-button--primary" [disabled]="zpetnaVazbaForm.invalid || isSubmitting()">
              {{ isSubmitting() ? ('zv.form.odesilam' | localize) : ('zv.form.odeslat' | localize) }}
            </button>
          </form>
        } @else {
          <h3>{{ 'zv.form.dekujeme' | localize }}</h3>
          <p>{{ 'zv.form.odeslano' | localize }}</p>
        }

      </div>
    </div>
    }
</div>